import TUIRoomEngine__default from "@tencentcloud/tuiroom-engine-js";
import { isVue3 } from "../utils/constants.mjs";
const roomEngine = { instance: null };
const vueVersion = isVue3 ? "vue3" : "vue2";
function useGetRoomEngine() {
  return roomEngine;
}
TUIRoomEngine__default.once("ready", () => {
  roomEngine.instance = new TUIRoomEngine__default();
  TUIRoomEngine__default.callExperimentalAPI(
    JSON.stringify({
      api: "setFramework",
      params: {
        component: "TUIRoomKit",
        language: vueVersion
      }
    })
  );
});
export {
  useGetRoomEngine as default
};
